<template>
  <div class="page_recruit_set" v-loading="loading" element-loading-text="加载中···">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
        <div class="main-con">
            <div class="crumbs">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>雇员</el-breadcrumb-item>
                <el-breadcrumb-item>设置</el-breadcrumb-item>
                <el-breadcrumb-item>{{activeName=='first'?'简历资源分配':'批量项目设置'}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="p_recruit_set">
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="s_tabs_box">
                    <el-tab-pane v-if="checkPermission(['employeeSet_tab_divide'],permissionLists)" :disabled="loading" label="简历资源分配" name="first"></el-tab-pane>
                    <!-- <el-tab-pane v-if="checkPermission(['employeeSet_tab_batch'],permissionLists)" :disabled="loading" label="批量项目设置" name="second"></el-tab-pane> -->
                    <el-tab-pane v-if="checkPermission(['employeeSet_tab_label'],permissionLists)" :disabled="loading" label="标签管理" name="third"></el-tab-pane>
                </el-tabs>
                <div class="p_form1_box" v-if="activeName == 'first'">
                    <el-form ref="enterForm" :model="infoQuery" class="re_down_form" label-width="240px">
                        <el-form-item label="报名简历自动分配至:" prop="StrUserName">
                            <el-select size="small"
                                v-model="useridList1" filterable clearable multiple @change="oneSelChange1"
                                placeholder="请选择人员"
                            >
                                <el-option
                                    v-for="(item, index) in memberList"
                                    :key="index"
                                    :label="item.Username"
                                    :value="item.Userid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="个人资源库本人创建简历自动分配至:" prop="StrMobile">
                            <el-select size="small"
                                v-model="useridList2" filterable clearable multiple @change="oneSelChange2"
                                placeholder="请选择人员"
                            >
                                <el-option
                                    v-for="(item, index) in memberList"
                                    :key="index"
                                    :label="item.Username"
                                    :value="item.Userid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-checkbox v-model="infoQuery.isChecked1">报名简历自动释放至公海</el-checkbox>
                        </el-form-item>
                        <el-form-item>
                            <el-checkbox v-model="infoQuery.isChecked2">个人资源库本人创建简历自动释放至公海</el-checkbox>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                            type="primary"
                            @click="saveHandle"
                            size="small"
                            >保存</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="p_form2_box" v-if="activeName == 'second'">
                    <el-form ref="batchForm" :model="batchQuery" class="re_down_form" label-width="60px">
                        <el-form-item label="项目:">
                            <el-select size="small" style="width:460px;"
                                v-model="checkproList" filterable clearable multiple @change="batchSelChange"
                                placeholder="请选择项目"
                            >
                                <el-option
                                    v-for="(item, index) in projectList"
                                    :key="index"
                                    :label="item.StrprojectName"
                                    :value="item.Projectid">
                                </el-option>
                            </el-select>
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="saveProHandle">确定启动</el-button>
                        </el-form-item>
                    </el-form>
                    <div class="e_set_table">
                        <el-table v-loading="dialogLoading" border :data="authProData" style="width:100%;">
                            <el-table-column align="center" label="项目ID" width="80px">
                                <template slot-scope="{row}">
                                    <span>{{row.Projectid}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" label="项目名称" min-width="130px" fit show-overflow-tooltip>
                                <template slot-scope="{row}">
                                <span>{{row.StrprojectName}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" label="操作" min-width="70px">
                                <template slot-scope="{row}">
                                <el-button type="default" size="mini" @click="removeBatch(row)">移除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
      </div>
  </div>
</template>
  
<script>
import xz from "./../../common";
import ResourceComTabs from "./components/resourceComTabs.vue"
import checkPermission from '@/utils/permission' // 权限判断函数
export default {
  components: {
    ResourceComTabs
  },
  data() {
    return {
        dialogLoading:false,
        authProData:[],//有权限列表
        checkproList:[],
        projectList:[],
        batchQuery:{
            projectids:'',
            strIsImp:1 //1有权限  2 无
        },
        // 列表参数
        proQuery:{
            projectname:'', // 项目名称
            projectid:'', // 项目id
            custname:'', //客户名称
            strbusdep:'',//业绩归属部门
            strpartner2:'', //合伙人
            strDep1:'', //部门一级
            strDep2:'', //部门二级
            strDep3:'', //部门三级
            strservuserid:'',//客服
            strContractType:'',//合同业务类型
            actualtype:'',//实操业务类型
            strSignsubject:'',//签约主体
            socialInsurance:'',//社保
            busInsurance:'',
            strProProvince:'',//省份
            strProCity:'',//城市
            strBillmethod:'',//发票类型
            strinvoiceType:'',//开票方式
            strprojectlevel:'',//项目等级
            groupname:'',//所属集团名称
            strBusiStat:'', //项目状态
            perpage: 10000000,
            currpage: 1,
            strorgancode:'',
            roletype:'',
            strpartner:'', // 团队长
            dtInitDatestart:'', // 立项开始时间
            dtInitDateend:'', // 立项结束时间
            strAchieveowner:'', // 业绩归属人
            strAchievedep:'' //业绩归属人部门
        },
        tabids: [],
        activeName:'',
        loading: false,
        infoQuery: {
            strUserIds1: '', //报名userid
            strUserIds2: '', //个人资源userid
            strsignIspub: '否', //是  勾选  否不勾选 报名简历自动释放至公海
            strpriIspub: '否', //是  勾选  否不勾选 个人资源库本人创建简历自动释放至公海
            isChecked1: false,
            isChecked2: false
        },
        useridList1:[],
        useridList2:[],
        // 规则
        enterRules: {
            StrUserName: [
                { required: true, message: '请输入姓名', trigger: 'blur' }
            ],
            posCategoryList: [
                { type: 'array', required: true, message: '请选择意向岗位', trigger: 'change'}
            ]
        },
        // 人员列表
        memberList: [],
        roleType: localStorage.loginRoletype,
        // 按钮权限参数
        butQuery:{
          path:'/employeeSet',
          powerEnName:'employee'
        },
        permissionLists:[],
        // 新人员列表
        memberComQuery: {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "在职",
          strstation: "",
          strorgancode: ""
        }
    }
  },
  created() {
    this.proQuery.roletype = localStorage.loginRoletype
    this.getButtonPower()//按钮权限
  },
  methods: {
    checkPermission,
    // 获取按钮权限
    getButtonPower(){
      let param = this.$route.query.active
      let that = this
      xz.getbtnPowerIdBypage(this.butQuery).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let resmsg = res.msg
          if(!this.isNull(resmsg)){
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
            if(!that.isNull(param)){//从其他页面跳转过来
              that.activeName = param
              if(that.activeName == 'second'){
                  that.getImportProject()
                  that.getProList()
                  that.checkproList = []
                  that.batchQuery.projectids = ''
              }else{
                that.activeName = 'first'
                that.getDtl()
                that.getauthUserInfoByorgancode(that.memberComQuery)
              }
            }else{
              if((that.checkPermission(['employeeSet_tab_divide'],that.permissionLists))){
                that.activeName = 'first'
                that.getDtl()
                that.getauthUserInfoByorgancode(that.memberComQuery)
              }else if((!that.checkPermission(['employeeSet_tab_divide'],that.permissionLists))&&(that.checkPermission(['employeeSet_tab_batch'],that.permissionLists))){
                that.activeName = 'second'
                that.getImportProject()
                that.getProList()
                that.checkproList = []
                that.batchQuery.projectids = ''
              }else if((!that.checkPermission(['employeeSet_tab_divide'],that.permissionLists))&&(!that.checkPermission(['employeeSet_tab_batch'],that.permissionLists))&&(that.checkPermission(['employeeSet_tab_label'],that.permissionLists))){
                that.$router.push({
                    path: '/recruitManage',
                    query:{
                        active:'third'
                    }
                })
              }
            }
          }else{
            that.permissionLists = []
            that.activeName = ''
          }
        }else{
          that.permissionLists = []
          that.activeName = ''
        }
      })
    },
    handleClick(tab){
        // console.log('dd',tab)
        this.activeName = tab.name
        if(tab.name == 'first'){
          this.getDtl()
          this.getauthUserInfoByorgancode(this.memberComQuery)
        }
        if(tab.name == 'second'){
            this.getImportProject()
            this.getProList()
            this.checkproList = []
            this.batchQuery.projectids = ''
        }
        if(tab.name == 'third'){
            this.$router.push({
                path: '/recruitManage',
                query:{
                    active:'third'
                }
            })
        }
    },
    // 选择项目
    batchSelChange(val){
      // console.log('dd',val)
      this.batchQuery.projectids = val.toString()
    },
    // 确定启动
    saveProHandle(){
      if(this.isNull(this.checkproList)){
        this.$message({
          message: "请选择项目",
          type: "warning"
        })
        return
      }
      // console.log('dd',this.batchQuery)
      xz.saveProjectImpSet(this.batchQuery).then(res => {
        if (res.status == 'ok') {
          this.$message({
            message: "操作成功",
            type: "success"
          })
          this.getImportProject()
        }else{
          this.$message({
            message: "操作失败,请稍后再试",
            type: "error"
          })
        }
      })
    },
    // 移除
    removeBatch(row){
      let query = {
        projectids:row.Projectid,
        strIsImp:2 //1有权限  2 无
      }
      this.$confirm('此操作将移除该项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        xz.saveProjectImpSet(query).then(result => {
          if (result.status == 'ok') {
            this.$message({
              message: "操作成功",
              type: "success"
            })
            this.getImportProject()
          }else{
            this.$message({
              message: result.msg,
              type: "error"
            })
          }
        }).catch(err=>{
            console.log("err",err)
          })
      })
    },
    // 查询是否有权限--获取项目列表
    getImportProject(){
      this.dialogLoading = true
      xz.getProjectImpSet({roletype:this.proQuery.roletype}).then(res => {
        if (res.status == 'ok') {
          // console.log(99,res)
          if(!this.isNull(res.msg.data)){
            this.authProData = res.msg.data
          }else{
            this.authProData = []
          }
        }
        this.dialogLoading = false
      })
    },
    // 获取所有项目列表
    getProList(){
      xz.getProjectLists(this.proQuery).then(res => {
        // console.log('客户', res)
        if (res.status == 'ok') {
          this.projectList = res.msg
        } else {
          this.projectList = []
        }
      })
    },
    oneSelChange1(val){
        // console.log('val',val)
        this.infoQuery.strUserIds1 = val.toString()
    },
    oneSelChange2(val){
        // console.log('val2',val)
        this.infoQuery.strUserIds2 = val.toString()
    },
    // 设置的详情
    getDtl(){
        xz.getSetUpgdUserid().then(res => {
            // console.log('ttt',res)
            if (res.status == 'ok') {
                this.infoQuery = {
                    strUserIds1: this.isNull(res.msg.strUserIds1)?'':res.msg.strUserIds1, //报名userid
                    strUserIds2: this.isNull(res.msg.strUserIds2)?'':res.msg.strUserIds2, //个人资源userid
                    strsignIspub: res.msg.strsignIspub, //是  勾选  否不勾选 报名简历自动释放至公海
                    strpriIspub: res.msg.strpriIspub, //是  勾选  否不勾选 个人资源库本人创建简历自动释放至公海
                    isChecked1: res.msg.strsignIspub=='是'?true:false,
                    isChecked2: res.msg.strpriIspub=='是'?true:false
                }
                if(!this.isNull(res.msg.strUserIds1)){
                    this.useridList1 = res.msg.strUserIds1.split(',')
                    // 去除空值
                    this.useridList1 = this.useridList1.filter(function(s) {
                        return s && s.trim() // 注：IE9(不包含IE9)以下的版本没有trim()方法
                    })
                }
                if(!this.isNull(res.msg.strUserIds2)){
                    this.useridList2 = res.msg.strUserIds2.split(',')
                    // 去除空值
                    this.useridList2 = this.useridList2.filter(function(s) {
                        return s && s.trim() // 注：IE9(不包含IE9)以下的版本没有trim()方法
                    })
                }
            }
        })
    },
    //获取人员列表
    getauthUserInfoByorgancode(query) {
      xz.getauthUserInfoByorgancode(query).then(res => {
        if (res.status == 'ok') {
          if (res.totalcount > 0) {
            this.memberList = res.msg
          } else {
            this.memberList = []
          }
        } else {
          this.memberList = []
        }
      })
    },
    // 保存
    saveHandle(){
      // if(this.isNull(this.useridList1)){
      //   this.$message({
      //     message: "请选择分配人员",
      //     type: "warning"
      //   })
      //   return false
      // }
        if(this.infoQuery.isChecked1){
            this.infoQuery.strsignIspub = '是'
        }else{
            this.infoQuery.strsignIspub = '否'
        }
        if(this.infoQuery.isChecked2){
            this.infoQuery.strpriIspub = '是'
        }else{
            this.infoQuery.strpriIspub = '否'
        }
        // console.log('ttt',this.infoQuery)
        xz.saveSetUpgdUserid(this.infoQuery).then(res => {
            // console.log('ttt',res)
            if (res.status == 'ok') {
                this.$message({
                    message: "保存成功",
                    type: "success"
                })
            } else {
                this.$message({
                    message: "保存失败，请稍后再试",
                    type: "error"
                })
            }
        })
    },
    //判断是否为空(包含0)
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
    }
  }
}
</script>

<style scoped>
.btn_box{
  display: flex;
  justify-content: flex-end;
  padding-right: 15px;
}
.p_recruit_set{
    background-color: #fff;
}
.p_recruit_set .re_down_form{
    margin-top: 30px;
}
.p_form2_box{
    padding-bottom: 30px;
}
.p_form1_box{
    padding-bottom: 30px;
}
.e_set_table{
    padding:0 20px;
    box-sizing:border-box;
}
</style>

<style>
.p_form2_box .el-table .el-table__cell{
  padding: 4px 0;
}
.p_recruit_set .re_down_form .el-select{
    width: 600px;
}
</style>